function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlower6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg4409",
    viewBox: "0 0 79.374996 79.375002",
    height: 300,
    width: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-217.62499)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path879",
    style: {
      fill: "#160089",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 49.448418,228.3611 c 0,5.38974 -9.758539,29.083 -9.758539,29.083 0,0 -9.758892,-23.69326 -9.758892,-29.083 0,-5.38974 4.369152,-9.75889 9.758892,-9.75889 5.389385,0 9.758539,4.36915 9.758539,9.75889"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path881",
    style: {
      fill: "#160089",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 26.025032,229.97894 c 3.811057,3.81106 13.664847,27.46516 13.664847,27.46516 0,0 -23.654809,-9.85308 -27.465868,-13.66414 -3.8107046,-3.81106 -3.8107046,-9.98996 0,-13.80102 3.811059,-3.81106 9.990314,-3.81106 13.801021,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path883",
    style: {
      fill: "#160089",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 10.606173,247.68556 c 5.390091,0 29.083706,9.75854 29.083706,9.75854 0,0 -23.693615,9.75889 -29.083706,9.75889 -5.3893859,0 -9.75853821,-4.36915 -9.75853821,-9.75889 0,-5.38939 4.36915231,-9.75854 9.75853821,-9.75854"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path885",
    style: {
      fill: "#160089",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 12.224011,271.1086 c 3.811059,-3.81106 27.465868,-13.6645 27.465868,-13.6645 0,0 -9.85379,23.65481 -13.664495,27.46551 -3.811059,3.81071 -9.989962,3.81071 -13.801373,0 -3.8107046,-3.81105 -3.8107046,-9.98996 0,-13.80101"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path887",
    style: {
      fill: "#160089",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 29.930987,286.52745 c 0,-5.38974 9.758892,-29.08335 9.758892,-29.08335 0,0 9.758539,23.69361 9.758539,29.08335 0,5.38939 -4.369154,9.75854 -9.758539,9.75854 -5.38974,0 -9.758892,-4.36915 -9.758892,-9.75854"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path889",
    style: {
      fill: "#160089",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 53.353668,284.90961 c -3.810706,-3.8107 -13.663789,-27.46551 -13.663789,-27.46551 0,0 23.654101,9.85344 27.464808,13.6645 3.811058,3.8107 3.811058,9.98996 0,13.80101 -3.810707,3.81071 -9.989608,3.81071 -13.801019,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path891",
    style: {
      fill: "#160089",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 68.772524,267.20299 c -5.389385,0 -29.082645,-9.75889 -29.082645,-9.75889 0,0 23.69326,-9.75889 29.082645,-9.75889 5.38974,0 9.758892,4.3695 9.758892,9.75889 0,5.38974 -4.369152,9.75854 -9.758892,9.75889"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path893",
    style: {
      fill: "#160089",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 67.154687,243.77996 c -3.810355,3.81106 -27.464808,13.66414 -27.464808,13.66414 0,0 9.853083,-23.6541 13.663789,-27.46516 3.811411,-3.81106 9.990312,-3.81106 13.801019,0 3.811058,3.81106 3.811058,9.98996 0,13.80102"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path895",
    style: {
      fill: "#c4aadb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 59.02598,246.46284 c -2.373489,2.42675 -17.198975,8.7958 -17.198975,8.7958 0,0 6.039557,-14.96307 8.41234,-17.38947 2.373135,-2.42605 6.263921,-2.46909 8.689975,-0.096 2.426404,2.37314 2.469444,6.26357 0.09666,8.68963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path897",
    style: {
      fill: "#c4aadb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 45.597495,236.00721 c 0.03704,3.39337 -5.941835,18.37972 -5.941835,18.37972 0,0 -6.31049,-14.85018 -6.347883,-18.24426 -0.0374,-3.39337 2.682875,-6.17467 6.07695,-6.21241 3.393368,-0.0377 6.17502,2.68252 6.212768,6.07695"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path899",
    style: {
      fill: "#c4aadb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 28.70826,238.10835 c 2.426052,2.37278 8.795454,17.19862 8.795454,17.19862 0,0 -14.96307,-6.0392 -17.388769,-8.41234 -2.426759,-2.37348 -2.469445,-6.26356 -0.09666,-8.68997 2.373136,-2.42641 6.263924,-2.46944 8.689977,-0.0963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path901",
    style: {
      fill: "#c4aadb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 18.251572,251.53648 c 3.394075,-0.0374 18.38043,5.94219 18.38043,5.94219 0,0 -14.850183,6.30979 -18.243905,6.34753 -3.393722,0.0374 -6.175022,-2.68322 -6.212769,-6.07695 -0.0381,-3.39372 2.682875,-6.17537 6.076244,-6.21276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path903",
    style: {
      fill: "#c4aadb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 20.353069,268.42537 c 2.373137,-2.4257 17.198624,-8.79511 17.198624,-8.79511 0,0 -6.039204,14.96307 -8.411988,17.38948 -2.373135,2.4257 -6.263216,2.46874 -8.689622,0.0956 -2.426405,-2.37278 -2.469797,-6.26321 -0.09701,-8.68997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path905",
    style: {
      fill: "#c4aadb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 33.781555,278.88205 c -0.03739,-3.39372 5.94219,-18.38042 5.94219,-18.38042 0,0 6.310135,14.85018 6.347532,18.24425 0.03739,3.39337 -2.683582,6.17467 -6.076598,6.21242 -3.393724,0.0381 -6.175375,-2.68217 -6.213124,-6.07625"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path907",
    style: {
      fill: "#c4aadb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 50.670793,276.78091 c -2.426054,-2.37349 -8.795456,-17.19827 -8.795456,-17.19827 0,0 14.962717,6.0385 17.388768,8.41163 2.426759,2.37314 2.469444,6.26322 0.09666,8.68927 -2.372784,2.42641 -6.263921,2.4698 -8.689973,0.0974"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path909",
    style: {
      fill: "#c4aadb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 61.127124,263.35172 c -3.39372,0.0381 -18.380072,-5.94149 -18.380072,-5.94149 0,0 14.85053,-6.31013 18.243902,-6.34823 3.394075,-0.037 6.17502,2.68358 6.212416,6.0773 0.03739,3.39337 -2.681816,6.17538 -6.076246,6.21242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path911",
    style: {
      fill: "#7969b0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.702497,241.0424 c -0.04339,2.61726 -4.97346,14.04444 -4.97346,14.04444 0,0 -4.547307,-11.58416 -4.503915,-14.20177 0.04375,-2.61691 2.200275,-4.70359 4.817533,-4.66055 2.617613,0.0437 4.703588,2.20098 4.659842,4.81788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path913",
    style: {
      fill: "#7969b0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 31.636668,242.30182 c 1.819627,1.88136 6.4135,13.44718 6.4135,13.44718 0,0 -11.40707,-4.97557 -13.226699,-6.85659 -1.819627,-1.88171 -1.769533,-4.88209 0.111832,-6.70207 1.881011,-1.81998 4.881738,-1.77024 6.701367,0.11148"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path915",
    style: {
      fill: "#7969b0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 23.288181,252.43113 c 2.617259,0.0434 14.043731,4.97381 14.043731,4.97381 0,0 -11.584517,4.54766 -14.201423,4.50427 -2.617611,-0.0437 -4.703586,-2.20098 -4.660547,-4.81789 0.04374,-2.61761 2.20098,-4.70394 4.818239,-4.66019"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path917",
    style: {
      fill: "#7969b0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 24.547244,265.49696 c 1.881365,-1.81998 13.447536,-6.4135 13.447536,-6.4135 0,0 -4.975576,11.40707 -6.857293,13.22705 -1.881365,1.81963 -4.881739,1.76953 -6.701368,-0.11183 -1.820686,-1.88137 -1.769886,-4.88174 0.111125,-6.70172"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path919",
    style: {
      fill: "#7969b0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 34.676554,273.8458 c 0.04339,-2.61726 4.974166,-14.04373 4.974166,-14.04373 0,0 4.547307,11.58452 4.503915,14.20142 -0.04375,2.61726 -2.20063,4.70323 -4.817888,4.66019 -2.617258,-0.0434 -4.703585,-2.20062 -4.660193,-4.81788"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path921",
    style: {
      fill: "#7969b0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 47.742385,272.58673 c -1.81963,-1.88171 -6.4135,-13.44753 -6.4135,-13.44753 0,0 11.407069,4.97522 13.227047,6.85729 1.819982,1.88137 1.769534,4.88174 -0.111477,6.70137 -1.881362,1.82033 -4.882091,1.77024 -6.70207,-0.11113"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path923",
    style: {
      fill: "#7969b0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 56.091222,262.45743 c -2.617258,-0.0437 -14.043729,-4.97382 -14.043729,-4.97382 0,0 11.584162,-4.54766 14.201421,-4.50426 2.616906,0.0434 4.703233,2.20062 4.659841,4.81753 -0.04339,2.61726 -2.200626,4.70394 -4.817533,4.66055"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path925",
    style: {
      fill: "#7969b0",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 54.832157,249.39089 c -1.881362,1.82033 -13.44718,6.41385 -13.44718,6.41385 0,0 4.975225,-11.40671 6.856587,-13.22669 1.882071,-1.81998 4.882091,-1.76954 6.701718,0.11147 1.819982,1.88137 1.770592,4.88174 -0.111125,6.70137"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path927",
    style: {
      fill: "#242034",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.03527778
    },
    d: "m 44.192735,258.07593 c 0,2.75942 -2.237317,4.99603 -4.996392,4.99603 -2.759429,0 -4.996391,-2.23661 -4.996391,-4.99603 0,-2.75943 2.236962,-4.99639 4.996391,-4.99639 2.759075,0 4.996392,2.23696 4.996392,4.99639"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower6);
export default __webpack_public_path__ + "static/media/flower-6.bda09ae88918c2d4f03cd273ef2636a8.svg";
export { ForwardRef as ReactComponent };